import { useMemo } from "react";

import { StrategyExpandedInfo, useLenderStrategies } from "@bridgesplit/abf-react";
import { useLenderStrategiesPagination } from "app/api";
import { PositionsTable } from "app/components/common";
import { getStrategyDetailColumnDefs } from "app/components/portfolio/StrategiesSection";
import { COPY } from "app/constants";

import { useMarketContext } from "../common";

export default function UserAdvancedLendPositions() {
    const pagination = useLenderStrategiesPagination();
    const { principalMint } = useMarketContext();

    const {
        data: strategies,
        totalStrategies,
        isLoading,
        isFetching
    } = useLenderStrategies({
        filter: {
            ...pagination.backendPagination,
            principalMints: principalMint ? [principalMint] : undefined
        }
    });

    const columns = useMemo(() => getStrategyDetailColumnDefs(), []);
    const { visibleData } = pagination;
    const items = useMemo(() => visibleData(strategies), [visibleData, strategies]);

    return (
        <PositionsTable<StrategyExpandedInfo>
            items={items}
            columns={columns}
            getRowKey={(strategy) => strategy.strategy.address}
            page={pagination.params.page}
            setPage={pagination.setPage}
            pageSize={pagination.params.pageSize}
            totalCount={totalStrategies}
            emptyPlaceholder={`You don't have any ${COPY.STRATEGY_TERM_PLURAL.toLowerCase()}`}
            loading={isLoading || isFetching}
        />
    );
}
